export function formatCadenceChip(cadenceData) {
  const avgDays = Number(cadenceData?.publishingCadence?.averageDaysBetweenEpisodes);
  const patternRaw = cadenceData?.publishingCadence?.pattern || '';
  const pattern = String(patternRaw).toLowerCase();

  if (Number.isFinite(avgDays)) {
    if (avgDays <= 1.5) return 'Daily';
    if (avgDays <= 8) return 'Weekly';
    if (avgDays <= 16) return 'Biweekly';
    if (avgDays <= 35) return 'Monthly';
    return `${avgDays.toFixed(1)}d`;
  }

  if (pattern.includes('daily')) return 'Daily';
  if (pattern.includes('biweekly')) return 'Biweekly';
  if (pattern.includes('weekly')) return 'Weekly';
  if (pattern.includes('monthly')) return 'Monthly';
  if (pattern.includes('mixed')) return 'Mixed';
  if (pattern.includes('irregular')) return 'Irregular';

  return patternRaw ? String(patternRaw).slice(0, 18) : '—';
}

export function formatDurationChip(minutes) {
  const mins = Number(minutes);
  if (!Number.isFinite(mins)) return '—';

  const rounded = Math.round(mins);
  if (rounded < 60) return `${rounded}m`;

  const hours = Math.floor(rounded / 60);
  const rem = rounded % 60;
  return rem === 0 ? `${hours}h` : `${hours}h ${rem}m`;
}
